<template>
    <transition name="el-fade-in">
        <div v-if="visible" class="cry-dialog"    @click.self="$emit('closeRateLow',false)">
            <!-- lớp icon khóc trôi -->
            <div class="cry-layer">
            </div><!-- thay span emoji hiện tại -->
            <span
                v-for="p in tears"
                :key="p.id"
                class="cry"
                :style="cryStyle(p)"
                @animationend="removeTear(p.id)"
            >
  <span class="cry__inner"><img :src="require('@/assets/images/rating-1.svg')" alt=""></span>
</span>

            <!-- ... các phần khác giữ nguyên ... -->
            <div class="cry-card">
                <div class="cry-head">
                    <div class="cry-emoji">
                        <img :src="require('@/assets/images/rating-1.svg')" alt="">
                    </div>
                    <div>
                        <div class="cry-title">{{ title }}</div>
                    </div>
                </div>

                <div class="cry-body">
                    <slot>
                        {{ subtitle }}
                    </slot>
                </div>

                <!-- BẮT ĐẦU: Form validation -->
                <el-form ref="cryForm" :model="form" :rules="cryRules" label-position="top">
                    <el-form-item prop="comment">
                        <el-input
                            type="textarea"
                            :rows="4"
                            placeholder="Gửi góp ý đến đội dự án"
                            v-model="form.comment"
                        />
                    </el-form-item>

                    <div class="cry-actions" style="margin-top: 20px">
                        <el-button @click="$emit('closeRateLow', true)">Vẫn đánh giá</el-button>
                        <el-button class="submit-rate" type="primary" @click="handleFeedback"> Góp ý
                        </el-button>
                    </div>
                </el-form>
                <!-- KẾT THÚC: Form validation -->
            </div>
        </div>
    </transition>
</template>

<script>
import ZimbraMailService from "@/services/ZimbraMailService";

export default {
    name: 'CryDialog',
    props: {

        visible: { type: Boolean, default: false },
        title:   { type: String,  default: 'Hãy gửi tới đội dự án góp ý!' },
        subtitle:{ type: String,  default: '"Xin lỗi bạn về trải nghiệm không tốt về vMail. Đừng vội đánh giá sao thấp, hãy gửi ý kiến đóng, góp ý của bạn qua hòm thư góp ý để đội dự án làm tốt hơn."' }
    },
    data() {
        return {
            form: { comment: '' },
            tears: [],
            timer: null,
            nextId: 1,
            formRating: {
                m: {
                    su: "Ý kiến khảo sát người dùng hệ thống vMail",
                    e: [
                        {
                            "t": "t",
                            "a": "hotro_vmail@viettel.com.vn",
                            "p": "Hỗ trợ vMail"
                        },
                        {
                            "t": "f",
                            a: "",
                        }
                    ],
                    mp: [
                        {
                            "ct": "multipart/alternative",
                            mp: [
                                {
                                    "ct": "text/plain",
                                    content: ""
                                }
                            ]
                        }
                    ]
                },
            },
            cryRules: {
                comment: [
                    { required: true, message: 'Vui lòng nhập ý kiến đóng góp', trigger: ['blur', 'change'] },
                    { min: 5, message: 'Ít nhất 5 ký tự', trigger: ['blur', 'change'] }
                ]
            },
        };
    },
    watch: {
        visible(v) {
            if (v) this.start(); else this.stop(true);
        }
    },
    mounted() {
        if (this.visible) this.start();
    },
    beforeDestroy() { this.stop(true); },
    methods: {
        handleFeedback(){
            this.$refs.cryForm.validate((ok) => {
                if (!ok) return;
                this.buildFormRating();
                this.$emit('confirm', false);
            });

        },
        buildFormRating() {
            this.formRating.m.mp[0].mp[0].content = this.form.comment;
            this.formRating.m.e[1].a = this.$store.state.EmailModule?.emailAddress;
            ZimbraMailService.sendMsgRequest(this.formRating);
        },
        start() {
            if (this.timer) return;
            this.timer = setInterval(() => {
                const batch = 1 + Math.floor(Math.random() * 3);
                for (let i = 0; i < batch; i++) this.spawn();
            }, 600);
        },
        stop(clearAll = false) {
            if (this.timer) { clearInterval(this.timer); this.timer = null; }
            if (clearAll) this.tears = [];
        },
        spawn() {
            if (this.tears.length > 36) this.tears.splice(0, 12);
            const id = this.nextId++;
            const x = 10 + Math.random() * 80;   // % left
            const size = 22 + Math.random() * 14;
            const duration = 2200 + Math.random() * 2400;
            const delay = Math.random() * 200;
            const dx = (Math.random() * 2 - 1) * 40;
            const rot = (Math.random() * 2 - 1) * 18;
            const opacity = 0.7 + Math.random() * 0.3;
            this.tears.push({ id, x, size, duration, delay, dx, rot, opacity });
        },
        cryStyle(p) {
            return {
                left: p.x + '%',
                fontSize: p.size + 'px',
                animationDuration: p.duration + 'ms',
                animationDelay: p.delay + 'ms',
                '--dx': p.dx + 'px',
                '--float-y': '-70vh',
                opacity: p.opacity
            };
        },
        removeTear(id) {
            const i = this.tears.findIndex(t => t.id === id);
            if (i >= 0) this.tears.splice(i, 1);
        }
    }
};
</script>

<style  scoped>
.cry-dialog {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: grid;
    place-items: center;
    background: rgba(0,0,0,.35);
    padding: 16px;
}

.cry-card {
    position: relative;
    width: 520px;
    max-width: 95vw;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 10px 28px rgba(0,0,0,.22);
    padding: 16px;
    overflow: hidden;
}

.cry-head {
    display: flex; gap: 12px; align-items: center; margin-bottom: 8px;
}
.cry-emoji { font-size: 28px; }
.cry-title { font-weight: 700; font-size: 16px; }

.submit-rate {
    background-color: var(--color-primary) !important;
    border-color: var(--color-primary) !important;
}
.cry-body { margin: 8px 0 16px; color: #111827; }

.cry-actions { display: flex; justify-content: flex-end; gap: 10px; }

/* layer icon khóc trôi – không chặn thao tác */
/* đặt layer emoji TRÊN card nhưng không chặn click */
.cry-layer { position:absolute; inset:0; pointer-events:none; overflow:hidden; z-index:3; }
.cry-card  { position:relative; z-index:2; }

/* Outer: chỉ bay lên tới giữa màn hình */
.cry {
    position: absolute;
    bottom: -12%;
    transform: translate3d(0,0,0);
    animation-name: float-cry;
    animation-timing-function: ease-out;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;   /* giữ trạng thái đến khi remove */
}

/* Inner: lắc vô hạn, KHÔNG ảnh hưởng translate của outer */
.cry__inner {
    display: inline-block;
    animation: wiggle-cry 1500ms ease-in-out infinite;
    transform-origin: 50% 70%;
}

@keyframes float-cry {
    0%   { transform: translate(0, 0); opacity: 0; }
    10%  { opacity: 1; }
    100% { transform: translate(var(--dx, 0px), var(--float-y, -70vh)); opacity: 0; }
}

/* Lắc nhẹ */
@keyframes wiggle-cry {
    0%,100% { transform: rotate(0deg); }
    25%     { transform: rotate(-6deg); }
    50%     { transform: rotate(5deg); }
    75%     { transform: rotate(-3deg); }
}

</style>
